import feedbackApi from "../../api/feedback";
import { Store } from "vuex";
import { stat } from "fs";
import Vue from "vue";

const state = {
  participants: [],
  areas: [],
  scale: null,
  lang: null,
  langId: null,
  isActive: false,
  name: "",
  dateStart: "",
  dateEnd: "",
  relations: [],
  editedEvaluated: [],
  relationTypes:[]
};

const getters = {
  participants(state, getters, rootState) {
    return state.participants;
  },
  
};

const actions = {
  loadFeedback({ commit, state }) {
    feedbackApi.getFeedback(state.courseId, state.langId).then(data => {
      const feedback = data.feedback;
      const lang = data.lang;
      const name = feedback.name;

      const areas = data.areas || [];
      const participants = data.participants || [];

      const dateStart = feedback.course_date_start;
      const dateEnd = feedback.course_date_end;

      const completionRate = data.completionRate;

      let globalScale = null;
      for (let i = 0; i < areas.length; i++) {
        for (let j = 0; j < areas[i].question.length; j++) {
          const scale = areas[i].question[j].scale;
          if (scale != null) {
            globalScale = scale;
          }
        }
      }

      for (let i = 0; i < participants.length; i++) {
        const participant = participants[i];
        participant.progress = JSON.parse(participant.result).progress;
      }

      const type = feedback.feedback_label;

      commit("setName", { name });
      commit("setDateStart", { dateStart });
      commit("setDateEnd", { dateEnd });
      commit("setParticipants", { participants });
      commit("setCompletionRate", { completionRate });
      commit("setAreas", { areas });
      commit("setScale", { scale: globalScale });
      commit("setLang", { lang });
      commit("setType", { type });
      commit("setIsActive", { isActive: feedback.active });
    });
  },
  loadRelationTypes({ commit, state }) {
    feedbackApi.getRelationTypes(state.courseId).then(data => {
      commit("setRelationTypes", { relationTypes: data });
    });
  },
  loadAllRelations({ commit, state }) {
    return feedbackApi.getAllRelations(state.courseId).then(data => {
      commit("setAllRelations", { relations: data });
    });
  },
  
}

const mutations = {
  setName(state, { name }) {
    state.name = name;
  },
  setDateStart(state, { dateStart }) {
    state.dateStart = dateStart;
  },
  setDateEnd(state, { dateEnd }) {
    state.dateEnd = dateEnd;
  },
  setParticipants(state, { participants }) {
    state.participants = participants;
  },
  setAreas(state, { areas }) {
    state.areas = areas;
  },
  setScale(state, { scale }) {
    state.scale = scale;
  },
  setCompletionRate(state, { completionRate }) {
    state.completionRate = completionRate;
  },
  setIsActive(state, { isActive }) {
    state.isActive = isActive;
  },
  setLang(state, { lang }) {
    state.lang = lang;
  },
  setLangId(state, { langId }) {
    state.langId = langId;
  },
  setCourseId(state, { courseId }) {
    state.courseId = courseId;
  },
  setRelationTypes(state, { relationTypes }) {
    Vue.set(state,"relationTypes",relationTypes);
    
  },
  setAllRelations(state, { relations }) {
    state.relations = relations;
  },
  addEditedEvaluated(state, { evaluatedId }) {
    state.editedEvaluated = [...state.editedEvaluated, evaluatedId];
  },
  setType(state, { type }) {
    state.type = type;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/public_app/store/modules/feedback.js